import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ColDef } from 'ag-grid-community';
import { ConfirmationMessageComponent } from 'src/app/shared/components/sqp-components/sqpMensajeConfirmacion/components/confirmation-message/confirmation-message.component';
import { DatosExcel } from 'src/app/shared/ExportadorFicheros/models/datos-excel';
import { DatosPdf } from 'src/app/shared/ExportadorFicheros/models/datos-pdf';
import { ExportadorExcelService } from 'src/app/shared/ExportadorFicheros/services/exportador-excel.service';
import { ExportadorPdfService } from 'src/app/shared/ExportadorFicheros/services/exportador-pdf.service';
import { FiltroBasico } from 'src/app/shared/models/filtros';
import { EmpresasModel } from '../../models/empresas-model';
import { EmpresasBarraSuperiorComponent } from '../empresas-barra-superior/empresas-barra-superior.component';
import { NuevaEmpresaModalComponent } from '../nueva-empresa-modal/nueva-empresa-modal.component';
import { RecuperaEmpresasApiService } from '../../services/recupera-empresas-api.service';
import { DatosEmpresasService } from '../../services/datos-empresas.service';
import { GridColDefsEmpresas } from '../../models/grid-col-defs-empresas';
import { EmpresasModalComponent } from '../empresas-modal/empresas-modal.component';
import { SpinnerModalComponent } from 'src/app/shared/components/others/spinner-modal/spinner-modal.component';
import { ModalMessageComponent } from 'src/app/shared/components/modals/modal-message/modal-message.component';
import { TipoMensajeConfirmacion } from 'src/app/shared/components/sqp-components/sqpMensajeConfirmacion/models/confirmation-message-data';
import { EmpleadoCrud } from 'src/app/pages/empleados/models/empleado';
import { DatosEmpleadosService } from 'src/app/pages/empleados/services/mantenimiento/datos-empleados.service';
import { OrdenColumna } from 'src/app/shared/models/orden-columna';
import { Observable } from 'rxjs';
import { SpinnerModalSqpComponent } from 'src/app/shared/components/sqp-components/sqpModales/spinner-modal-sqp/spinner-modal-sqp.component';
import { finalize } from 'rxjs/operators';
import { SqpGridComponentComponent } from 'src/app/shared/components/sqp-components/sqpGrid/sqp-grid-component/sqp-grid-component.component';
import { PaginationHelperService } from 'src/app/shared/services/pagination-helper.service';


@Component({
  selector: 'app-empresas-page',
  templateUrl: './empresas-page.component.html',
  styleUrls: ['./empresas-page.component.css']
})
export class EmpresasPageComponent implements OnInit {

  empresas: EmpresasModel[];
  filtros: FiltroBasico[] = [];
  @ViewChild(EmpresasBarraSuperiorComponent) barrSuperior!: EmpresasBarraSuperiorComponent;
  columnDefs: ColDef[] = new GridColDefsEmpresas().columnDefs;
  empresasSeleccionadas: EmpresasModel[] = [];
  textoBorrar: string = '';
  empleados: EmpleadoCrud[]=[];

  currentPage = 1;
  hasMoreRows = true;
  isLoading = false;
  dialogRefSpinner: any;
  ordenColumna: OrdenColumna;

  gridOptions:any={
    suppressScrollOnNewData: true
  }
  @ViewChild(SqpGridComponentComponent) sqpGrid: SqpGridComponentComponent;
  gridSuppressSelectionEvents: boolean = false;

  constructor(public datosEmpresasService: DatosEmpresasService,
              public dialog: MatDialog,
              private exportadorPdfService: ExportadorPdfService,
              private exportadorExcelService: ExportadorExcelService,
              private datosEmpresasApiService: RecuperaEmpresasApiService,
              private datosEmpleadosService: DatosEmpleadosService,
              private cdRef: ChangeDetectorRef,
              private paginationHelper: PaginationHelperService) { }

  ngOnInit() {
    this.filtros.push({
      text: 'Buscar',
      textoBuscar: '',
      value: ''
      })
    this.reloadData();
    if(this.datosEmpleadosService.empleados.length==0) this.getEmpleados();
  }

  getEmpresas(origen: string, closeSpinner: boolean = true){
    this.isLoading = true;
    this.datosEmpresasService.getEmpresas(this.filtros, this.currentPage, this.ordenColumna)
      .pipe(finalize(() => {
        this.isLoading = false;
      })).subscribe({
        next: (response: EmpresasModel[]) => {

          this.empresas = [...this.empresas,...response];
          this.currentPage++;
          const returnedRowCount = response.length;
          if (returnedRowCount < 50) this.hasMoreRows = false;
          else this.hasMoreRows = true;

          this.isLoading = false;

          // Re-select previously selected rows after rows are rendered (only if not loading all rows)
          this.cdRef.detectChanges();
          requestAnimationFrame(() => {
            // Only re-select if we're not in the middle of loading all rows
            if (closeSpinner) {
              this.selectPreviouslySelectedRows();
            }
            // Allow selection events again after re-select is applied
            this.gridSuppressSelectionEvents = false;
          });
          // Close spinner only after data is assigned and a paint tick (if closeSpinner is true)
          if (closeSpinner && this.dialogRefSpinner) {
            this.cdRef.detectChanges();
            requestAnimationFrame(() => {
              this.dialogRefSpinner?.close();
            });
          }
        },
        error: (error) => {
          console.error('Error loading rows:', error);
          if (closeSpinner) {
            this.dialogRefSpinner?.close();
          }
        }
      }
      )
  }

//SELECCIONAR/DESELECCIONAR EMPRESAS

  seleccionEmpresas(event: EmpresasModel[]){
    this.empresasSeleccionadas = event;
    if(this.empresasSeleccionadas.length > 1) this.textoBorrar = `${event.length} empresas seleccionadas`;
    else this.textoBorrar = `${event.length} empresa seleccionada`;
  }

  deseleccionarAll(){
    this.sqpGrid.api.deselectAll();
  }

  selectPreviouslySelectedRows() {
    this.paginationHelper.selectPreviouslySelectedRows(
      this.sqpGrid.api,
      {
        selectedItems: this.empresasSeleccionadas,
        identifierField: 'codigoEmpresa'
      }
    );
  }

  selectAllRowsInGrid() {
    this.sqpGrid.api.forEachNodeAfterFilter((node:any) => {
      node.setSelected(true);
    });
  }

  onHeaderSelectionToggled(allSelected: boolean){
    if (allSelected) {
      if(this.hasMoreRows){
        const dialogRef = this.dialog.open(ConfirmationMessageComponent, {
          data: {
            tipo: TipoMensajeConfirmacion.ConfirmacionSimple,
            titulo: 'Seleccionar todos los registros',
            mensaje: '<p>Para seleccionar todos los registros se tienen que descargar todos los datos, el proceso puede tardar más de lo habitual. ¿Desea continuar?</p>',
            textoConfirmacion: 'Seleccionar todos',
            textoCancelar: 'cancelar'
          }
        });
        dialogRef.afterClosed().subscribe(result => {
          if(result === 'OK'){
            // Show spinner and load all remaining rows when "select all" is clicked
            this.dialogRefSpinner = this.dialog.open(SpinnerModalSqpComponent);
            // Don't select rows yet, just load all data first
            this.loadAllRemainingRows();
          }
        });
      }else{ //no preguntamos ya que toda la data ya está cargada
        this.dialogRefSpinner = this.dialog.open(SpinnerModalSqpComponent);
        this.loadAllRemainingRows();
      }

    } else {
      // Update selection text and backup for deselect all
      this.empresasSeleccionadas = [];
    }
  }

  private loadAllRemainingRows() {
    if (this.isLoading || !this.hasMoreRows) {
      // All rows loaded, now select all and paint them
      this.empresasSeleccionadas = [...this.empresas];
      this.textoBorrar = `${this.empresasSeleccionadas.length} empresas seleccionadas`;

      // Select all rows in the grid and paint them blue
      this.cdRef.detectChanges();
      requestAnimationFrame(() => {
        this.selectAllRowsInGrid();
        // Close spinner after selection is complete
        if (this.dialogRefSpinner) {
          this.dialogRefSpinner.close();
        }
      });
      return;
    }

    // Load next batch of rows (without showing spinner since we already have one)
    this.loadRowsWithoutSpinner();

    // After loading, check if we need to load more
    setTimeout(() => {
      this.loadAllRemainingRows();
    }, 1000);
  }
//FIN SELECCIONAR/DESELECCIONAR EMPRESAS

//LLAMADAS PARA ACTUALIZAR LOS DATOS DEL GRID
  reloadData(origen?: string){
    this.currentPage = 1;
    this.empresas = [];
    this.hasMoreRows = true;
    this.dialogRefSpinner = this.dialog.open(SpinnerModalSqpComponent);
    this.getEmpresas('reloadData');
  }

  loadRows(){
    if(this.isLoading || !this.hasMoreRows) return; // Prevent duplicate requests
    else{
      this.gridSuppressSelectionEvents = true;
      this.dialogRefSpinner = this.dialog.open(SpinnerModalSqpComponent);
      this.getEmpresas('scroll');
    }
  }

  loadRowsWithoutSpinner(){
    if(this.isLoading || !this.hasMoreRows) return;
    else{
      this.gridSuppressSelectionEvents = true;
      this.getEmpresas('scroll', false); // Don't close spinner
    }
  }

  ordenarGrid(event: OrdenColumna){
    this.ordenColumna = event;
    this.reloadData();
  }
//FIN LLAMADAS PARA ACTUALIZAR LOS DATOS DEL GRID

//ACCIONES EDITAR/ELIMINAR/CREAR NUEVA EMPRESA
  clickBarraSuperior(id: string){
    switch (id) {
      case 'Excel':
        this.exportaExcel();
        break;
      case "Pdf":
        this.exportaPdf();
        break;
      case id.match(/(Buscar:.*)/)?.input:
        let textoBuscar = id.replace('Buscar:','');
        this.buscarEmpresas(textoBuscar);
        break;
      case "Plus":
        this.creaNuevaEmpresa();
        break;
      default:
        break;
    }
  }

  creaNuevaEmpresa(){
    const dialogRef = this.dialog.open(NuevaEmpresaModalComponent, {
      data: {},
      panelClass: 'modal-class-detalle',
      position: { right: '0'}
    });

    dialogRef.afterClosed().subscribe(result=>{
      if(result === 'OK'){
        this.reloadData();
      }
    })
  }

  buscarEmpresas(textoBuscar:string){
    if(this.empresas){
      this.filtros[0].textoBuscar = textoBuscar;
      this.filtros[0].text = 'Buscar';
      this.filtros[0].value = textoBuscar;
      this.reloadData('buscar');
    }
  }

  quitarFiltro(filtro: FiltroBasico){
    this.barrSuperior.buscarTexto('');
  }

  abreModal(empresa:any){
    let info: any = {};
    info.empresa = empresa.data;
    info.nuevo = false;
    const dialogRef = this.dialog.open(EmpresasModalComponent, {
      data: info,
      panelClass: 'modal-class-detalle',
      position: { right: '0'}
    });

    // Store the row information and scroll position
    const editedRowId = empresa.data.codigoEmpresa;
    const rowIndex = empresa.rowIndex;
    const initialCurrentPage = this.currentPage;

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'OK') {
        // Reload data and maintain scroll position
        this.reloadDataAndMaintainScroll(editedRowId, rowIndex, initialCurrentPage);
      }
    });
  }

  private reloadDataAndMaintainScroll(editedRowId: string, originalRowIndex: number, targetPage: number) {
    // Store current scroll position
    const scrollTop = this.sqpGrid.api.getVerticalPixelRange()?.top || 0;

    // Clear and reload data
    this.empresas = [];
    this.currentPage = 1;
    this.hasMoreRows = true;
    this.dialogRefSpinner = this.dialog.open(SpinnerModalSqpComponent);

    // Load data up to the target page to maintain the same data context
    this.loadDataUpToPage(targetPage, editedRowId, originalRowIndex, scrollTop);
  }

  private loadDataUpToPage(targetPage: number, editedRowId: string, originalRowIndex: number, scrollTop: number) {
    if (this.isLoading || !this.hasMoreRows || this.currentPage > targetPage) {
      // All data loaded, now restore scroll
      this.restoreScrollAndSelectRow(editedRowId, originalRowIndex, scrollTop);
      return;
    }

    this.isLoading = true;
    this.datosEmpresasService.getEmpresas(this.filtros, this.currentPage, this.ordenColumna).subscribe({
      next: (response: any) => {

        this.empresas = [...this.empresas,...response];
        this.currentPage++;
        const returnedRowCount = response.length;
        if (returnedRowCount < 50) this.hasMoreRows = false;
        else this.hasMoreRows = true;

        this.isLoading = false;

        // Continue loading if we haven't reached the target page and there are more rows
        if (this.currentPage <= targetPage && this.hasMoreRows) {
          this.loadDataUpToPage(targetPage, editedRowId, originalRowIndex, scrollTop);
        } else {
          this.restoreScrollAndSelectRow(editedRowId, originalRowIndex, scrollTop);
        }
      },
      error: (error) => {
        console.error('Error loading rows:', error);
        this.isLoading = false;
        this.restoreScrollAndSelectRow(editedRowId, originalRowIndex, scrollTop);
      }
    });
  }

  private restoreScrollAndSelectRow(editedRowId: string, originalRowIndex: number, scrollTop: number) {

    // Wait for the grid to render the data
    this.cdRef.detectChanges();
    requestAnimationFrame(() => {
      // Find the edited row and focus on the first editable cell
      this.sqpGrid.api.forEachNodeAfterFilter((node: any) => {
        if (node.data.codigoEmpresa === editedRowId) {
          // Ensure the row is visible
          this.sqpGrid.api.ensureNodeVisible(node);

          // Focus on the first editable cell
          const columnToFocus = 'nombreEmpresa';
          this.sqpGrid.api.setFocusedCell(node.rowIndex, columnToFocus);
        }
      });

      if (this.dialogRefSpinner) {
        this.dialogRefSpinner.close();
      }
    });
  }

  eliminarEmpresa(){
    let empresasConCentros: EmpresasModel[] = [];
    this.empresasSeleccionadas.forEach(x=>{
      if(x.centros.length>0) empresasConCentros.push(x)
    })
    let empresasConEmpleados: EmpresasModel[] = [];
    this.datosEmpleadosService.empleados.forEach(empleado => {
      this.empresasSeleccionadas.forEach(empresa => {
        if(empleado.codigoEmpresa==empresa.codigoEmpresa) empresasConEmpleados.push(empresa);
      })
    })
    if(empresasConCentros.length>0){
      this.dialog.open(ModalMessageComponent, {
        data: {
          mensaje: this.empresasSeleccionadas.length>1 ? `Hay centros asociados a las empresas seleccionadas. Para poder borrarlas, primero se deben eliminar los centros asociados.`:`Hay centros asociados a la empresa seleccionada. Para poder borrarla, primero se deben eliminar los centros asociados.`,
          alert: true
        },
      });
    }else if(empresasConEmpleados.length>0){
      this.dialog.open(ModalMessageComponent, {
        data: {
          mensaje: this.empresasSeleccionadas.length>1 ? `Hay empleados asociados a las empresas seleccionadas. Para poder borrarlas, primero se deben eliminar los empleados asociados.`:`Hay empleados asociados a la empresa seleccionada. Para poder borrarla, primero se deben eliminar los empleados asociados.`,
          alert: true
        },
      });
    }else{
      const dialogRef = this.dialog.open(ConfirmationMessageComponent, {
        data: {
          tipo: TipoMensajeConfirmacion.ConfirmacionCompleja,
          icono: 'hs-bin',
          titulo: this.empresasSeleccionadas.length>1? '¿Eliminar empresas?':'¿Eliminar empresa?',
          // preguntaConfirmacion: '¿Eliminar empresa?',
          textoConfirmacion: this.empresasSeleccionadas.length>1?'Eliminar las empresas seleccionadas':'Eliminar la empresa seleccionada',
          textoBoton: 'Eliminar',
          iconoConfirmacion: 'hs-bin'
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        if(result === 'OK'){
          const dialogRefSpinner = this.dialog.open(SpinnerModalComponent);
          let count: number = 0;
          this.empresasSeleccionadas.forEach(x=>{
            this.datosEmpresasApiService.deleteEmpresa(x).subscribe(
              next => {
                count++;
                if(this.empresasSeleccionadas.length == count){
                  dialogRefSpinner.close();
                  const dialogRef = this.dialog.open(ModalMessageComponent, {
                    data: {
                      mensaje: this.empresasSeleccionadas.length>1?'Empresas eliminadas correctamente':'Empresa eliminada correctamente',
                    },
                    });
                    this.datosEmpresasApiService.refreshEmpresas = true;
                    this.reloadData();
                }
              },
              error => {
                dialogRefSpinner.close();
                const dialogRef = this.dialog.open(ModalMessageComponent, {
                  data: {
                    mensaje: 'Error. La empresa no se ha eliminado',
                    alert: true
                  },
                });
              }
            );
          })

        }
      });
    }
  }

//FIN ACCIONES EDITAR/ELIMINAR/CREAR NUEVA EMPRESA

//EXPORTAR PDF/EXCEL
  exportaPdf(){
    if(this.empresas){
      const dialogRef = this.dialog.open(ConfirmationMessageComponent, {
        data: {
          tipo: TipoMensajeConfirmacion.ConfirmacionSimple,
          icono: 'icon-pdf-empty',
          titulo: 'Generar PDF',
          mensaje: '<p>Genera un documento PDF con la información de los registros mostrados en el listado</p>',
          textoConfirmacion: 'Generar PDF',
          iconoConfirmacion: 'icon-pdf-empty',
          textoCancelar: 'cancelar'
        }
      });

      //montamos el objeto a pasar al servicio con el modelo DatosPdf
      const datos = this.montarParametrosPdf();

      dialogRef.afterClosed().subscribe(result => {
        if(result === 'OK'){
          if(this.hasMoreRows){
            this.dialogRefSpinner = this.dialog.open(SpinnerModalSqpComponent);
            this.datosEmpresasService.getEmpresas(this.filtros, 0).subscribe({
              next: (response: any) => {
                this.empresas=response;
                this.exportadorPdfService.exportaPdf(datos, this.empresas);
                this.dialogRefSpinner.close();
              },
              error: (error) => {
                console.error('Error loading rows:', error);
                this.dialogRefSpinner.close();
              }
            })
          }else{
            this.exportadorPdfService.exportaPdf(datos, this.empresas);
          }

        }
      });
    }
  }

  montarParametrosPdf(): DatosPdf{
    let columns: any [] = [];
    this.columnDefs.forEach( x => {
      columns.push( {header: x.headerName, dataKey: x.field} )
    })
    let fecha = new Date();
    let datosPdf = {
      landscape: true,
      nombreFichero:`Hire&Sign_empresas_${fecha.getFullYear()}${fecha.getMonth()+1}${fecha.getDate()}${fecha.getHours()}${fecha.getMinutes()}${fecha.getSeconds()}.pdf`,
      registros: columns
    }
    return datosPdf
  }

  exportaExcel(){
    if(this.empresas){
      const dialogRef = this.dialog.open(ConfirmationMessageComponent, {
        data: {
          tipo: TipoMensajeConfirmacion.ConfirmacionSimple,
          icono: 'icon-excel-empty',
          titulo: 'Generar excel',
          mensaje: '<p>Genera un documento Excel con la información de los registros mostrados en el listado</p>',
          textoConfirmacion: 'Generar excel',
          iconoConfirmacion: 'icon-excel-empty',
          textoCancelar: 'cancelar'
        }
      });


      let datosExcel = this.montarParametrosExcel();

      dialogRef.afterClosed().subscribe(result => {
        if(result === 'OK'){
          if(this.hasMoreRows){
            this.dialogRefSpinner = this.dialog.open(SpinnerModalSqpComponent);
            this.datosEmpresasService.getEmpresas(this.filtros, 0).subscribe({
              next: (response: any) => {
                this.empresas=response;
                let rows = this.GetRows(this.empresas);
                this.exportadorExcelService.exportaExcel(datosExcel, rows)
                this.dialogRefSpinner.close();
              },
              error: (error) => {
                console.error('Error loading rows:', error);
                this.dialogRefSpinner.close();
              }
            })
          }else{
            let rows = this.GetRows(this.empresas);
            this.exportadorExcelService.exportaExcel(datosExcel, rows)
          }
        }
      });
    }
  }

  montarParametrosExcel(): DatosExcel{
    let fecha = new Date();
    let datosExcel = {
      workSheetName:'Empresas',
      nombreFichero:`Hire&Sign_empresas_${fecha.getFullYear()}${fecha.getMonth()+1}${fecha.getDate()}${fecha.getHours()}${fecha.getMinutes()}${fecha.getSeconds()}.xlsx`,
      columnas: this.GetColumns()
    }
    return datosExcel
  }

  //Generamos las columnas basandonos en las del grid
  private GetColumns(): any[]{
    let columns:any[] = [];
    this.columnDefs.forEach(x => {
        let element:any = {};
        element.name = x.headerName;
        element.filterButton = true;
        element.width = x.width;
        columns.push(element);
    });
    return columns;
  }

  // Mapeamos los datos de las empresas a las filas del excel
  private GetRows(data:EmpresasModel[]):any[]{
    let rows:any[] = [];
    data.forEach(x=>{
      let row:any[] =
      [
        x.codigoEmpresa,
        x.nombreEmpresa,
        x.cif,
        this.getNombreEmpleado(x),
        x.emailEmpleado
      ];
      rows.push(row);
    });
    return rows
  }

  getNombreEmpleado(empresa: EmpresasModel): string{
    let nombreFinal: string;
    if(empresa.nombreEmpleado && empresa.apellido1Empleado) nombreFinal = `${empresa.nombreEmpleado} ${empresa.apellido1Empleado}`;
    else if(empresa.nombreEmpleado && !empresa.apellido1Empleado) nombreFinal = `${empresa.nombreEmpleado}`;
    return nombreFinal
  }
//FIN EXPORTAR PDF/EXCEL

  getEmpleados(){
    this.datosEmpleadosService.getEmpleados([],0).subscribe(
      next => {
        this.empleados = next;
      },
      error => {
        console.error();
      }
    )
  }

}
